import React from 'react';
import '../../../css/page-breadcrumbs.less';

/**
 * Breadcrumbs UI component for navigation between pages
 *
 * @param {Array} items Set of breadcrumbs
 * @param {Function} navigateTo onClick function for navigation to a page specified by the breadcrumb
 */
export const PageBreadcrumbs = ({ items, navigateTo }) => {
    const breadcrumbs = items;

    const buildItem = (item, index) => {
        const isFirst = index === 0;
        const isLast = index === breadcrumbs.length - 1;

        const crumb = (!isLast)
            ? <button className="breadcrumbs-link" onClick={() => navigateTo(item.id)}>{item.label}</button>
            : <span>{item.label}</span>;

        return (
            <li key={`${item.label}-${index}`} className="breadcrumbs-item">
                {!isFirst && <span>&nbsp;&gt;&nbsp;</span>}
                {crumb}
            </li>
        );
    };

    const buildBreadcrumbs = () => breadcrumbs.map((item, index) => buildItem(item, index));

    return (
        <nav>
            <ul className="breadcrumbs-list">
                {buildBreadcrumbs()}
            </ul>
        </nav>
    );
};

export default PageBreadcrumbs;
